import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {AdditionalPropertyLabelComponent} from "./additional-property-label.component";
import {SummaryFieldModule} from "../../../../core/component/summary-field/summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        SummaryFieldModule,
    ],
    declarations: [
        AdditionalPropertyLabelComponent,
    ],
    exports: [
        AdditionalPropertyLabelComponent
    ]
})
export class AdditionalPropertyLabelModule {}